// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3354":"5dba74f3","6961":"e258a233"}[chunkId] + ".chunk.css";
};